/* eslint-disable no-use-before-define */
import {
  Model, createActionCreaters, Effects, Reducers,
} from '@shuwen/dva-ts-wrapper';
import * as apiServer from '@/services/api';
import { MTools } from '@/components';
import {
  Data,
  GlobalState,
} from './types';

export interface ISubscriptionModelState {
  banners: any[];
  news: any[];
  bbs: any[];
  topic: any[];
  schedule: any[];
  file: any[];
  vipUsers: any[];
  booth: any[];
}

interface IReducersPayloads {
  save: void | Partial<ISubscriptionModelState>;
}

interface IEffectsPayloads {
  getBanners: Data;
  getNews: Data;
  getFile: Data;
  getBbs: Data;
  getTopic: Data;
  getSchedule: Data;
  getVipUsers: Data;
  getBooth: Data;
}

const reducers: Reducers<ISubscriptionModelState, IReducersPayloads> = {
  save(state, action) {
    return {
      ...state,
      ...action.payload,
    };
  },
};

const effects: Effects<GlobalState, IEffectsPayloads> = {
  *getBanners({ payload }, { call, put }) {
    const result = yield call(apiServer.getMediaList, { columnType: 'banner' });
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          banners: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },
  *getNews({ payload }, { call, put }) {
    const result = yield call(apiServer.getMediaList, { columnType: 'news' });
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          news: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },
  *getBbs({ payload }, { call, put }) {
    const result = yield call(apiServer.getBbsList);
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          bbs: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },
  *getTopic({ payload }, { call, put }) {
    const result = yield call(apiServer.getTopicList);
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          topic: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },
  *getSchedule({ payload }, { call, put }) {
    const result = yield call(apiServer.getActivityScheduleList);
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          schedule: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },
  *getFile({ payload }, { call, put }) {
    const result = yield call(apiServer.getMediaList, { columnType: 'document' });
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          file: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },
  *getBooth({ payload }, { call, put }) {
    const result = yield call(apiServer.getBoothList);
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          booth: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },
  *getVipUsers({ payload }, { call, put }) {
    const result = yield call(apiServer.getVipUserList);
    if (result) {
      if (result.success) {
        yield put(subscriptionActions.reducers.save({
          vipUsers: result.data,
        }));
      } else {
        MTools.Tips('error', (result && (result.msg || result.message)) || '系统异常，请刷新再试');
      }
    }
  },

};


const SubscriptionModel: Model<ISubscriptionModelState, GlobalState, IReducersPayloads, IEffectsPayloads> = {
  namespace: 'subscription',
  state: {
    banners: [],
    news: [],
    bbs: [],
    topic: [],
    schedule: [],
    file: [],
    vipUsers: [],
    booth: [],
  },

  subscriptions: {
    setup({ dispatch, history }) {  // eslint-disable-line

    },
  },

  effects,
  reducers,
};

export default SubscriptionModel;

export const subscriptionActions = createActionCreaters(SubscriptionModel);
